/* TVP delivery promise — our own engine (promise.tradevehicleparts.co.uk). Test theme 2026-09-03, cart deliveries 2026-09-07.
   Initialises #tvp-promise (product) and #tvp-promise-cart (cart) whenever they appear, so it
   survives themes that re-render the product form after load. Renders nothing on error.
   NOTE: the product block lives inside the theme's <form action="/cart/add">. Never add a
   nested <form>, and always cancel Enter in the postcode field, or the browser submits
   the product form (= an accidental add to cart). */
(function () {
  if (!window.fetch) return;

  function savedPc() { try { return (localStorage.getItem('tvp_pc') || '').trim(); } catch (e) { return ''; } }
  function savePc(v) { try { localStorage.setItem('tvp_pc', v); } catch (e) { } }
  function tidyPc(v) { return (v || '').toUpperCase().replace(/[^A-Z0-9 ]/g, '').replace(/\s+/g, ' ').trim(); }
  function looksLikePc(v) { return /^[A-Z]{1,2}\d[A-Z\d]?\s?\d?[A-Z]{0,2}$/.test(tidyPc(v)); }
  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }
  function fmtLeft(s) {
    s = Math.max(0, s | 0);
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
    if (d > 0) return plural(d, 'day') + ', ' + plural(h, 'hour');
    if (h > 0) return plural(h, 'hour') + ', ' + plural(m, 'minute');
    if (m > 0) return plural(m, 'minute');
    return 'under a minute';
  }
  function shortDate(iso) {
    try { return new Date(iso + 'T12:00:00').toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { return iso; }
  }
  function req(url, opts, timeoutMs) {
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, timeoutMs || 4000);
    opts = opts || {};
    opts.signal = ctrl ? ctrl.signal : undefined;
    opts.credentials = 'omit';
    return fetch(url, opts).then(function (r) {
      clearTimeout(to);
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }, function (e) { clearTimeout(to); throw e; });
  }

  function initProduct(el) {
    if (!el || el.dataset.tvpInit) return;
    el.dataset.tvpInit = '1';

    var txt = el.querySelector('.tvp-promise__text');
    var sub = el.querySelector('.tvp-promise__sub');
    var note = el.querySelector('.tvp-promise__pc-note');
    var input = el.querySelector('.tvp-promise__pc-input');
    var btn = el.querySelector('.tvp-promise__pc-btn');
    var verified = el.querySelector('.tvp-promise__verified');
    if (input) input.value = savedPc();

    var timer = null, data = null, fetchedAt = 0, manual = false;

    function setNote(msg) { if (note) note.textContent = msg || ''; }

    function render() {
      if (!data) { el.hidden = true; return; }
      var st = data.status;
      var dated = (st === 'ok' || st === 'remote_priced') && data.promise_label;
      el.classList.toggle('tvp-promise--answered', manual && !!dated);
      if (verified) verified.hidden = !(manual && !!dated);
      if (dated) {
        var left = data.seconds_to_cutoff - Math.floor((Date.now() - fetchedAt) / 1000);
        if (data.seconds_to_cutoff > 0 && left <= 0) { load(true); return; }
        var when = '<b>' + data.promise_label + '</b>' +
          (data.promise_date_max ? '<span class="tvp-promise__range">Latest ' + shortDate(data.promise_date_max) + '</span>' : '');
        // Always count down, the way the Delivery Timer does — the ticking clock is
        // the point. Over a day out it reads "2 days, 20 hours" rather than "68 hours".
        var urgent = left > 0;
        txt.innerHTML = 'Delivery by ' + when;
        var bits = [];
        if (urgent) bits.push('Order within <span class="tvp-promise__cd">' + fmtLeft(left) + '</span>');
        if (st === 'remote_priced') bits.push('Non-mainland delivery' + (data.price_note ? ' ' + data.price_note.replace(' per item', ' per item') : ''));
        else if (data.method_title) bits.push(data.method_title);
        if (data.postcode_used) bits.push('to ' + data.postcode_used);
        else if (data.zone_label) bits.push(data.zone_label);
        if (data.calendar_notes && data.calendar_notes.length) bits.push(data.calendar_notes.join('; '));
        sub.innerHTML = bits.join(' · ');
        // Pick up: how soon this item is usually ready (stock same day, ordered-in parts longer).
        if (data.collect_label) sub.innerHTML += '<br><span class="tvp-promise__collect">' + data.collect_label + '</span>';
        el.hidden = false;
      } else if (st === 'collection_only') {
        txt.innerHTML = '<b>Collection only</b> from our Leicestershire warehouse for this item.';
        sub.textContent = ''; el.hidden = false;
      } else if (st === 'remote_priced') {
        txt.innerHTML = '<b>Non-mainland delivery</b>' + (data.price_note ? ' — ' + data.price_note : '') + ', date confirmed at checkout.';
        sub.textContent = data.zone_label || ''; el.hidden = false;
      } else if (st === 'no_delivery' && manual) {
        txt.innerHTML = '<b>No delivery to ' + (data.postcode_used || 'that postcode') + '</b> for this item.';
        sub.textContent = data.message || ''; el.hidden = false;
      } else {
        el.hidden = true;
      }
    }

    function load(force) {
      var p = savedPc();
      var url = el.dataset.endpoint +
        '?tags=' + encodeURIComponent(el.dataset.tags || '') +
        '&sku=' + encodeURIComponent(el.dataset.sku || '') +
        '&variant_id=' + encodeURIComponent(el.dataset.variant || '') +
        (p ? '&postcode=' + encodeURIComponent(p) : '');
      if (btn) btn.disabled = true;
      req(url, { cache: force ? 'reload' : 'default' }).then(function (d) {
        data = d; fetchedAt = Date.now();
        if (btn) btn.disabled = false;
        setNote('');
        render();
        if (timer) clearInterval(timer);
        timer = setInterval(render, 30000);
      }, function () {
        if (btn) btn.disabled = false;
        if (manual) setNote('Could not check that postcode just now.');
        else el.hidden = true;
      });
    }

    function check() {
      var v = tidyPc(input && input.value);
      if (v && !looksLikePc(v)) { setNote('That does not look like a UK postcode.'); return; }
      if (input) input.value = v;
      savePc(v);
      manual = true;
      setNote('');
      load(true);
    }

    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); check(); });
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); e.stopPropagation(); check(); }
    });

    document.addEventListener('variant:change', function (e) {
      try {
        var v = e.detail && e.detail.variant;
        if (!v) return;
        // A sold-out variant gets no promise at all.
        if (v.available === false) { data = null; el.hidden = true; return; }
        el.dataset.sku = v.sku || el.dataset.sku;
        el.dataset.variant = v.id || el.dataset.variant;
        load(true);
      } catch (err) { }
    });

    load(false);
  }

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shortTitle(t, n) { t = String(t || '').replace(/\s+/g, ' ').trim(); return t.length > n ? esc(t.slice(0, n - 1).replace(/\s+\S*$/, '')) + '…' : esc(t); }

  // ── Cart page ──────────────────────────────────────────────────────────
  // One quote for the basket. When the items would arrive on different days the
  // engine returns them grouped into deliveries; we show each delivery with its
  // date and items, and a small line under each product in the table. Nothing
  // says why a delivery is separate — only when it arrives.
  function initCart(el) {
    if (!el || el.dataset.tvpInit) return;
    el.dataset.tvpInit = '1';
    var items;
    try { items = JSON.parse(document.getElementById('tvp-promise-cart-items').textContent); } catch (e) { return; }
    if (!items || !items.length) return;

    var t = el.querySelector('.tvp-promise__text'), s = el.querySelector('.tvp-promise__sub'),
        ships = el.querySelector('.tvp-promise__ships');
    var data = null, fetchedAt = 0, tick = null, refreshTimer = null;
    var VANI = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M3 5h11v9h1.2l2.3-4H21v6h-1a2.5 2.5 0 1 1-5 0H9a2.5 2.5 0 1 1-5 0H3V5Zm14 6h2.6l-1.7 3H17v-3ZM6.5 15.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm11 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/></svg>';

    function clearLines() {
      var ls = document.querySelectorAll('[data-tvp-line]');
      for (var i = 0; i < ls.length; i++) { ls[i].hidden = true; ls[i].innerHTML = ''; }
    }
    function lineFor(item) {
      if (!item) return null;
      var row = item.key ? document.querySelector('[data-cart-item-key="' + item.key.replace(/"/g, '') + '"]') : null;
      return row ? row.querySelector('[data-tvp-line]') : null;
    }
    function itemNames(ship) {
      var names = [];
      for (var i = 0; i < ship.items.length; i++) {
        var it = items[ship.items[i].index];
        var q = ship.items[i].quantity;
        names.push(shortTitle(it && it.title ? it.title : ship.items[i].sku, 70) + (q > 1 ? ' <span class="tvp-promise__qty">×' + q + '</span>' : ''));
      }
      return names.join('<br>');
    }

    function render() {
      var d = data;
      if (!d) { el.hidden = true; return; }
      var left = (d.seconds_to_cutoff || 0) - Math.floor((Date.now() - fetchedAt) / 1000);
      if (d.seconds_to_cutoff > 0 && left <= 0) { load(); return; }     // a cut-off passed while the page sat open
      var split = d.split && d.shipments && d.shipments.length > 1;
      clearLines();
      ships.innerHTML = '';
      el.classList.toggle('tvp-promise--split', !!split);
      if ((d.status === 'ok' || d.status === 'remote_priced') && d.promise_label) {
        if (split) {
          t.innerHTML = 'Your order will arrive in <b>' + esc(d.split_word || d.shipments.length) + ' deliveries</b>' +
            (left > 0 ? ' — check out in the next <span class="tvp-promise__cd">' + fmtLeft(left) + '</span> to keep these dates' : '');
          var html = '';
          for (var i = 0; i < d.shipments.length; i++) {
            var sh = d.shipments[i];
            html += '<li><span class="tvp-promise__ship-when">' + VANI + '<span class="tvp-promise__ship-n">Delivery ' + sh.n + '</span> <span>by</span> <b>' + esc(sh.promise_label) + '</b></span>' +
                    '<span class="tvp-promise__ship-items">' + itemNames(sh) + '</span></li>';
            for (var j = 0; j < sh.items.length; j++) {
              var ln = lineFor(items[sh.items[j].index]);
              if (ln) { ln.innerHTML = VANI + '<span>Delivery ' + sh.n + ' of ' + d.shipments.length + ' · by <b>' + esc(sh.promise_label_short || sh.promise_label) + '</b></span>'; ln.hidden = false; }
            }
          }
          ships.innerHTML = html;
        } else {
          t.innerHTML = left > 0
            ? 'Check out in the next <span class="tvp-promise__cd">' + fmtLeft(left) + '</span> and your order will arrive by <b>' + esc(d.promise_label) + '</b>'
            : 'Your order will arrive by <b>' + esc(d.promise_label) + '</b>';
        }
        var bits = [];
        if (d.status === 'remote_priced') bits.push('Non-mainland delivery' + (d.price_note ? ' ' + d.price_note : ''));
        else if (d.method_title) bits.push(d.method_title);
        if (d.postcode_used) bits.push('to ' + d.postcode_used);
        if (d.calendar_notes && d.calendar_notes.length) bits.push(d.calendar_notes.join('; '));
        s.textContent = bits.join(' · ');
        el.hidden = false;
      } else if (d.status === 'collection_only') {
        t.innerHTML = '<b>Collection only</b> — an item in your basket cannot be shipped.'; s.textContent = ''; el.hidden = false;
      } else if (d.status === 'remote_priced') {
        t.innerHTML = '<b>Non-mainland delivery</b> — price and date confirmed at checkout.'; s.textContent = ''; el.hidden = false;
      } else {
        el.hidden = true;
      }
    }

    function load() {
      var p = savedPc();
      req(el.dataset.endpoint, {
        method: 'POST', headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ items: items, postcode: p || null })
      }).then(function (d) {
        data = d; fetchedAt = Date.now();
        render();
        if (!tick) tick = setInterval(render, 30000);
      }, function () { data = null; clearLines(); el.hidden = true; });
    }

    // The basket can change without a reload (quantity steppers, Remove). Re-read it
    // from Shopify a moment later and quote again; the engine looks tags up by SKU.
    function refreshFromCart() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        req('/cart.js', { credentials: 'same-origin' }).then(function (c) {
          var fresh = [];
          for (var i = 0; i < (c.items || []).length; i++) {
            var it = c.items[i];
            fresh.push({ sku: it.sku, quantity: it.quantity, key: it.key, title: it.product_title || it.title, tags: [] });
          }
          if (!fresh.length) { data = null; clearLines(); el.hidden = true; return; }
          items = fresh;
          load();
        }, function () { });
      }, 1500);
    }
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-cart-remove], [data-quantity-button], .js-qty__adjust')) refreshFromCart(); });
    document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('[data-quantity-input], input[name^="updates"]')) refreshFromCart(); });

    load();
  }


  // ── Reg-lookup listing pages ───────────────────────────────────────────
  // The body-panel and TecDoc results share one card renderer, which drops a
  // <div data-tvp-sku="..."> into each card. We fill them all from one batched
  // request and keep the countdown ticking, so the urgency is on the listing
  // page too, not only the product page.
  var BATCH_URL = 'https://promise.tradevehicleparts.co.uk/promise/batch';
  var listingTimer = null, listingCards = [], listingTick = null;

  function listingStyle() {
    if (document.getElementById('tvp-lp-style')) return;
    var st = document.createElement('style');
    st.id = 'tvp-lp-style';
    st.textContent =
      '.tvp-lp{display:none;align-items:flex-start;gap:7px;margin:10px 0 2px;padding:8px 10px;' +
      'background:#f8f8f8;border:1px solid #e0e0e0;border-radius:6px;' +
      'font-family:Poppins,-apple-system,"Segoe UI",Helvetica,Arial,sans-serif;' +
      'font-size:12.5px;line-height:1.4;color:#444;text-align:left}' +
      '.tvp-lp.on{display:flex}' +
      '.tvp-lp svg{width:15px;height:15px;flex:0 0 15px;color:#c63031;margin-top:1px}' +
      '.tvp-lp b{color:#0f0f0f;font-weight:700;white-space:nowrap}' +
      '.tvp-lp .cd{color:#c63031;font-weight:700;font-variant-numeric:tabular-nums;white-space:nowrap}' +
      '@media (max-width:600px){.tvp-lp{font-size:12px;padding:7px 9px}}';
    document.head.appendChild(st);
  }

  var VAN = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M3 5h11v9h1.2l2.3-4H21v6h-1a2.5 2.5 0 1 1-5 0H9a2.5 2.5 0 1 1-5 0H3V5Zm14 6h2.6l-1.7 3H17v-3ZM6.5 15.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm11 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/></svg>';

  function renderCard(card) {
    var d = card.data, el = card.el;
    if (!d) { el.className = 'tvp-lp'; return; }
    var body = '';
    if ((d.status === 'ok' || d.status === 'remote_priced') && d.promise_label) {
      var left = (d.seconds_to_cutoff || 0) - Math.floor((Date.now() - card.at) / 1000);
      body = left > 0
        ? 'Order in the next <span class="cd">' + fmtLeft(left) + '</span> for delivery by <b>' + d.promise_label + '</b>'
        : 'Delivery by <b>' + d.promise_label + '</b>';
      if (d.status === 'remote_priced' && d.price_note) body += ' &middot; ' + d.price_note;
    } else if (d.status === 'collection_only') {
      body = '<b>Collection only</b> from our Leicestershire warehouse';
    } else { el.className = 'tvp-lp'; return; }
    el.innerHTML = VAN + '<span>' + body + '</span>';
    el.className = 'tvp-lp on';
  }

  function runListing() {
    var nodes = [];
    var all = document.querySelectorAll('[data-tvp-sku]');
    for (var i = 0; i < all.length; i++) if (!all[i].dataset.tvpDone) nodes.push(all[i]);
    if (!nodes.length) return;
    listingStyle();
    var skus = [];
    nodes.forEach(function (n) {
      n.dataset.tvpDone = '1';
      n.className = 'tvp-lp';
      var s = (n.getAttribute('data-tvp-sku') || '').trim();
      if (s && skus.indexOf(s) < 0) skus.push(s);
    });
    if (!skus.length) return;
    var pc = savedPc();
    // A listing of parts nobody has looked at before makes the engine fetch their
    // tags first, so this one call gets longer than the product page's.
    req(BATCH_URL, { method: 'POST', headers: { 'content-type': 'application/json' },
                     body: JSON.stringify({ skus: skus, postcode: pc || null }) }, 12000)
      .then(function (resp) {
        var res = (resp && resp.results) || {};
        var now = Date.now();
        nodes.forEach(function (n) {
          var card = { el: n, data: res[(n.getAttribute('data-tvp-sku') || '').trim()] || null, at: now };
          listingCards.push(card);
          renderCard(card);
        });
        if (!listingTick) listingTick = setInterval(function () { listingCards.forEach(renderCard); }, 30000);
      }, function () { });
  }

  function initListing() {
    if (!document.querySelector('[data-tvp-sku]:not([data-tvp-done])')) return;
    clearTimeout(listingTimer);
    listingTimer = setTimeout(runListing, 150);
  }

  function scan() {
    initProduct(document.getElementById('tvp-promise'));
    initCart(document.getElementById('tvp-promise-cart'));
    initListing();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  try { new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true }); }
  catch (e) { setInterval(scan, 1500); }
})();
